import { render, staticRenderFns } from "./confirm.vue?vue&type=template&id=10830379&scoped=true&"
var script = {}
import style0 from "./confirm.vue?vue&type=style&index=0&id=10830379&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10830379",
  null
  
)

export default component.exports